/* ============================================
   NIGHTLIFE INJECTOR v11
   BOOK [logo] NOW button → /pages/reservation
   Mobile: centered absolute between hamburger & socials
   Desktop: inline between socials (Insta/TikTok) & cart
   ============================================ */

(function() {
  var SOCIAL_LINKS = {
    instagram: 'https://www.instagram.com/pubcrawl.nice',
    tiktok: 'https://www.tiktok.com/@pubcrawl.nice',
    whatsapp: ''
  };

  // BOOK NOW button now sends users to the dedicated Reservation page
  var BOOK_BTN_LINK = '/pages/reservation';
  var BOOK_BTN_LOGO_URL = 'https://cdn.shopify.com/s/files/1/0808/6080/7506/files/Sto_Crawl_2106ca16-98d1-4b12-adcd-c9b141a422c2.jpg?v=1768904378';

  var SVG_INSTAGRAM = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" stroke-width="1.8"/><circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="1.8"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg>';
  var SVG_TIKTOK = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.83a8.16 8.16 0 0 0 4.77 1.52V6.89a4.85 4.85 0 0 1-1.84-.2z"/></svg>';
  var SVG_WHATSAPP = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true"><path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.2-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6.1-.1.3-.3.4-.5.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.1-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5 0 1.5 1.1 2.9 1.2 3.1.1.2 2.1 3.2 5.1 4.5 1.8.8 2.5.8 3.4.7.5-.1 1.7-.7 1.9-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.6-.3zM12 2C6.5 2 2 6.5 2 12c0 1.7.5 3.4 1.3 4.8L2 22l5.3-1.3c1.4.8 3 1.2 4.7 1.2 5.5 0 10-4.5 10-10S17.5 2 12 2zm0 18c-1.5 0-3-.4-4.3-1.2l-.3-.2-3.2.8.8-3.1-.2-.3C3.9 14.9 3.5 13.5 3.5 12c0-4.7 3.8-8.5 8.5-8.5s8.5 3.8 8.5 8.5-3.8 8.5-8.5 8.5z"/></svg>';

  function buildSocialBlock() {
    var wrap = document.createElement('div');
    wrap.className = 'pcn-socials';
    wrap.setAttribute('data-pcn-socials', '');
    if (SOCIAL_LINKS.instagram) {
      var a1 = document.createElement('a');
      a1.href = SOCIAL_LINKS.instagram; a1.target = '_blank'; a1.rel = 'noopener';
      a1.setAttribute('aria-label', 'Instagram');
      a1.className = 'pcn-social pcn-social--ig';
      a1.innerHTML = SVG_INSTAGRAM;
      wrap.appendChild(a1);
    }
    if (SOCIAL_LINKS.tiktok) {
      var a2 = document.createElement('a');
      a2.href = SOCIAL_LINKS.tiktok; a2.target = '_blank'; a2.rel = 'noopener';
      a2.setAttribute('aria-label', 'TikTok');
      a2.className = 'pcn-social pcn-social--tt';
      a2.innerHTML = SVG_TIKTOK;
      wrap.appendChild(a2);
    }
    if (SOCIAL_LINKS.whatsapp) {
      var a3 = document.createElement('a');
      a3.href = SOCIAL_LINKS.whatsapp; a3.target = '_blank'; a3.rel = 'noopener';
      a3.setAttribute('aria-label', 'WhatsApp');
      a3.className = 'pcn-social pcn-social--wa';
      a3.innerHTML = SVG_WHATSAPP;
      wrap.appendChild(a3);
    }
    return wrap;
  }

  function buildBookButton(variant) {
    var a = document.createElement('a');
    a.className = 'pcn-book-btn';
    if (variant === 'desktop') {
      a.className += ' pcn-book-btn--desktop';
    } else {
      a.className += ' pcn-book-btn--mobile';
    }
    a.setAttribute('data-pcn-book', '');
    a.setAttribute('data-pcn-book-variant', variant || 'mobile');

    a.href = BOOK_BTN_LINK;
    a.setAttribute('aria-label', 'Book now');

    var leftSpan = document.createElement('span');
    leftSpan.className = 'pcn-book-btn__text pcn-book-btn__text--left';
    leftSpan.textContent = 'BOOK';

    var rightSpan = document.createElement('span');
    rightSpan.className = 'pcn-book-btn__text pcn-book-btn__text--right';
    rightSpan.textContent = 'NOW';

    var logoDiv = document.createElement('span');
    logoDiv.className = 'pcn-book-btn__logo';
    var logoImg = document.createElement('img');
    logoImg.src = BOOK_BTN_LOGO_URL;
    logoImg.alt = 'Pub Crawls Nissa';
    logoImg.loading = 'eager';
    logoDiv.appendChild(logoImg);

    a.appendChild(leftSpan);
    a.appendChild(rightSpan);
    a.appendChild(logoDiv);

    return a;
  }

  function removeExisting(selector) {
    var existing = document.querySelectorAll(selector);
    existing.forEach(function(el) { el.remove(); });
  }

  function findCart() {
    return document.querySelector('header a[href="/cart"]')
      || document.querySelector('header a[href*="/cart"]')
      || document.querySelector('header cart-icon')
      || document.querySelector('header [class*="cart-icon"]')
      || document.querySelector('header [class*="header__icon--cart"]');
  }

  function findLangSelector() {
    return document.querySelector('header localization-form')
      || document.querySelector('header [class*="localization"]')
      || document.querySelector('header [class*="locale-selector"]')
      || document.querySelector('header .localization-selector');
  }

  function findHamburger() {
    return document.querySelector('header [aria-label*="menu" i]')
      || document.querySelector('header [aria-label*="Menu"]')
      || document.querySelector('header .header__menu-toggle')
      || document.querySelector('header .header__menu-button')
      || document.querySelector('header menu-drawer-button')
      || document.querySelector('header summary');
  }

  function findHeaderRoot() {
    return document.querySelector('header-component')
      || document.querySelector('header.section-header')
      || document.querySelector('header');
  }

  function injectSocials() {
    removeExisting('[data-pcn-socials]');
    var isMobile = window.matchMedia('(max-width: 989px)').matches;
    var block = buildSocialBlock();
    if (!block.children.length) return true;

    if (isMobile) {
      var cart = findCart();
      if (cart && cart.parentNode) {
        cart.parentNode.insertBefore(block, cart);
        return true;
      }
    } else {
      var lang = findLangSelector();
      if (lang && lang.parentNode) {
        if (lang.nextSibling) lang.parentNode.insertBefore(block, lang.nextSibling);
        else lang.parentNode.appendChild(block);
        return true;
      }
      var cart2 = findCart();
      if (cart2 && cart2.parentNode) {
        cart2.parentNode.insertBefore(block, cart2);
        return true;
      }
    }
    return false;
  }

  function positionBookButtonMobile(btn) {
    var hamburger = findHamburger();
    var socials = document.querySelector('[data-pcn-socials]');
    if (!hamburger || !socials || !btn.parentNode) return;

    var parentRect = btn.parentNode.getBoundingClientRect();
    var hamRect = hamburger.getBoundingClientRect();
    var socRect = socials.getBoundingClientRect();

    var hamCenter = hamRect.left + hamRect.width / 2;
    var socLeft = socRect.left;
    var midpoint = (hamCenter + socLeft) / 2;
    var leftRelative = midpoint - parentRect.left;

    btn.style.left = leftRelative + 'px';
  }

  function injectBookButton() {
    removeExisting('[data-pcn-book]');
    removeExisting('[data-pcn-title]');
    var isMobile = window.matchMedia('(max-width: 989px)').matches;

    if (isMobile) {
      // ---- MOBILE: centered absolute between hamburger and socials ----
      var headerRoot = findHeaderRoot();
      if (!headerRoot) return false;

      var topRow = headerRoot.querySelector('.header__row--top')
        || headerRoot.querySelector('.header__row')
        || headerRoot.querySelector('.header__inner')
        || headerRoot;

      var currentPosition = window.getComputedStyle(topRow).position;
      if (currentPosition === 'static') {
        topRow.style.position = 'relative';
      }

      var btn = buildBookButton('mobile');
      topRow.appendChild(btn);

      requestAnimationFrame(function() {
        positionBookButtonMobile(btn);
        requestAnimationFrame(function() { positionBookButtonMobile(btn); });
      });

      return true;
    } else {
      // ---- DESKTOP: inline between socials (Insta/TikTok) and cart ----
      var socials = document.querySelector('[data-pcn-socials]');
      var cart = findCart();
      var btnD = buildBookButton('desktop');

      if (socials && socials.parentNode) {
        // insert right after socials so order is: Insta/TikTok > BOOK NOW > Cart
        if (socials.nextSibling) {
          socials.parentNode.insertBefore(btnD, socials.nextSibling);
        } else {
          socials.parentNode.appendChild(btnD);
        }
        return true;
      }
      if (cart && cart.parentNode) {
        // fallback: just before the cart
        cart.parentNode.insertBefore(btnD, cart);
        return true;
      }
      return false;
    }
  }

  function inject() {
    var ok1 = injectSocials();
    var ok2 = injectBookButton();
    return ok1 && ok2;
  }

  function init() {
    if (inject()) return;
    var tries = 0;
    var iv = setInterval(function() {
      tries++;
      if (inject() || tries > 30) clearInterval(iv);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  var lastIsMobile = window.matchMedia('(max-width: 989px)').matches;
  window.addEventListener('resize', function() {
    var nowIsMobile = window.matchMedia('(max-width: 989px)').matches;
    if (nowIsMobile !== lastIsMobile) {
      lastIsMobile = nowIsMobile;
      inject();
    } else if (nowIsMobile) {
      var btn = document.querySelector('[data-pcn-book][data-pcn-book-variant="mobile"]');
      if (btn) positionBookButtonMobile(btn);
    }
  });
})();
